import { Redirect, Route, Switch, useLocation } from "wouter";
import Dashboard from "./Dashboard";
import Login from "./pages/Login";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

function PrivateRoute({ component: Component, ...rest }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [location] = useLocation();

  if (isLoading) return null;
  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location || "/");
    return <Redirect to={`/login?redirect=${redirect}`} />;
  }
  return <Route {...rest} component={Component} />;
}

export default function App() {
  return (
    <AuthProvider>
      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute path="/" component={Dashboard} />
      </Switch>
    </AuthProvider>
  );
}


